import { ServiceUsingCountLimiter } from "@/services/license/license-limiters/base-limiters/service-using-count-limiter";
import { LicenseName } from "@/data/license.data";

export const trialTtmsCount = 1;
export const starterTtmsDayCount = 25;
export const creatorTtmsDayCount = 50;
export const studioTtmsDayCount = 100;

export class TextToMusicCountLimiter extends ServiceUsingCountLimiter {
  getPlanLimit(license: LicenseName): number {
    switch (license) {
      case "Premium":
        return Infinity;
      default:
        return 0;
    }
  }

  getUniqueLimit(userId: string): Promise<number | null> {
    return Promise.resolve(null);
  }
}
